import { EventBase } from "@vp/models";

export class FormSubmitEvent extends EventBase<boolean> {
  constructor(submit: boolean) {
    super();
    this.args = submit;
  }
}
